module.exports = __webpack_public_path__ + "static/media/slide_zh0.db99049a.jpg";